import { useEffect } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_USER_SERVER } from '@/app/module/user/definitions'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

type Options = {
  skip?: boolean
}

export const useGetUser = ({ skip = false }: Options = {}) => {
  const dispatch = useAppDispatch()

  const res = esApi.useGetUserQuery(undefined, { skip })

  useEffect(() => {
    if (!res.error) {
      return
    }

    dispatch(
      createNotification({
        'get-user': {
          type: 'error',
          message: ERROR_GET_USER_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
